export const environment = {
  production: false,
  apiUrl: 'https://hermes.teu.com.mx/kyc',
};
